import React, { useContext } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  makeStyles,
  Snackbar,
  Typography,
} from '@material-ui/core';
import PreferLocation from '../map/prefer-location';
import { TypeSelect } from '../component/type/type-select.component';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router-dom';
import { PreferLocationContext } from '../../../services/prefer-location/prefer-location.context';

const useStyle = makeStyles({
  saveButton: {
    margin: '1rem 0',
  },
  submitBox: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: '24px 16px 24px 0',
    position: 'relative',
  },
  buttonProgress: {
    color: '#000',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  TypeLoading: {
    margin: '16px 0 0 16px',
  },
});

export const PreferLocationContainer = () => {
  const classes = useStyle();
  const history = useHistory();

  const {
    open,
    error,
    findLocationLoading,
    saveLocationLoading,
    setError,
    savePreferLocation,
    handleClose,
  } = useContext(PreferLocationContext);

  return (
    <div>
      <PreferLocation setError={setError} />

      <Box pt={2} display='flex' alignItems='center'>

        <TypeSelect />

        {findLocationLoading && (
          <CircularProgress size={24} className={classes.TypeLoading} />
        )}
      </Box>

      <div className={classes.submitBox}>
        <div className={classes.wrapper}>
          <Button
            type='submit'
            color='primary'
            variant='contained'
            size='small'
            disabled={saveLocationLoading}
            onClick={savePreferLocation}
            id='save-location'
          >
            Save
          </Button>
          {saveLocationLoading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>
        <Button
          size='small'
          variant='outlined'
          disabled={saveLocationLoading}
          onClick={() => history.push('/meetings')}
        >
          Discard Changes
        </Button>
      </div>

      <Typography color='error' variant='caption'>
        {error}
      </Typography>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        TransitionComponent='alpha'
        message='saved'
        action={
          <>
            <IconButton
              size='small'
              aria-label='close'
              color='inherit'
              onClick={handleClose}
            >
              <CloseIcon fontSize='small' />
            </IconButton>
          </>
        }
      />
    </div>
  );
};
